import request from '../../axios';
import {IGetCooperationAgreementDateResponse} from './types';

export const getCooperationAgreementDate = async () => {
  const {data}: {data: IGetCooperationAgreementDateResponse} =
    await request.get(`/api/v2/store/cooperation-agreement-date`);

  return data;
};
